import React, { useState } from "react";
import "./CurrentHeatingInput.css";

const heatingOptions = [
  { label: "Gas boiler",       emoji: "🔥" },
  { label: "Electric heating", emoji: "⚡" },
  { label: "Heat pump",        emoji: "♻️" },
  { label: "Other",            emoji: "🏠" },
];

const heatPumpOptions = [
  { label: "No" },
  { label: "Yes: planning to install a heat pump" },
  { label: "Not sure yet" },
];

export default function CurrentHeatingInput({ nextStep, updateFormData }) {
  const [currentHeating, setCurrentHeating] = useState("");
  const [heatPumpPlans, setHeatPumpPlans]   = useState("");

  const hasHeatPump = currentHeating === "Heat pump";

  const handleContinue = () => {
    if (!currentHeating) {
      alert("Please tell us how you currently heat your home.");
      return;
    }
    if (!hasHeatPump && !heatPumpPlans) {
      alert("Please tell us about your heat pump plans.");
      return;
    }
    updateFormData({
      currentHeating,
      heatPumpPlans: hasHeatPump ? "Already have one" : heatPumpPlans,
    });
    nextStep();
  };

  return (
    <div className="current-heating-container">
      <div className="question-block">
        <h2>How do you currently heat your home?</h2>
        <div className="heating-options">
          {heatingOptions.map(({ label, emoji }) => (
            <button
              key={label}
              type="button"
              className={currentHeating === label ? "heating-btn selected" : "heating-btn"}
              onClick={() => {
                setCurrentHeating(label);
                if (label === "Heat pump") setHeatPumpPlans("");
              }}
            >
              {emoji} {label}
            </button>
          ))}
        </div>
      </div>

      {currentHeating && !hasHeatPump && (
        <div className="question-block">
          <h2>Are you planning to transition your heating to a heat pump?</h2>
          <div className="heating-options">
            {heatPumpOptions.map(({ label }) => (
              <button
                key={label}
                type="button"
                className={heatPumpPlans === label ? "heating-btn selected" : "heating-btn"}
                onClick={() => setHeatPumpPlans(label)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      )}

      {currentHeating && (hasHeatPump || heatPumpPlans) && (
        <button className="continue-button" onClick={handleContinue}>
          Continue
        </button>
      )}
    </div>
  );
}
